import { httpsCallable } from 'firebase/functions';
import { auth, functionsClient } from '../firebaseConfig';

const fallbackEndpoint = 'https://us-central1-micgro-manager.cloudfunctions.net/listMyFarmsHttp';

const parseFarms = (payload) => {
  const farms = payload?.farms;
  return Array.isArray(farms) ? farms : [];
};

export async function listMyFarmsClient() {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    return [];
  }

  await currentUser.getIdToken(true);
  const idToken = await currentUser.getIdToken();

  try {
    const response = await fetch(fallbackEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
      },
      body: JSON.stringify({}),
    });

    const data = await response.json().catch(() => ({}));
    if (response.ok) {
      return parseFarms(data);
    }
  } catch {
    // Fall back to callable below.
  }

  const callable = httpsCallable(functionsClient, 'listMyFarms');
  const result = await callable({});
  return parseFarms(result?.data);
}
